import { Result } from '@standardnotes/domain-core';
import { Challenge, ChallengePrompt, ChallengeReason, ChallengeValidation, } from '../Challenge';
import { Strings } from './Strings';
export class GetFilePassword {
    constructor(challenges) {
        this.challenges = challenges;
    }
    async execute() {
        const challenge = new Challenge([new ChallengePrompt(ChallengeValidation.None, Strings.FileAccountPassword, undefined, true)], ChallengeReason.DecryptEncryptedFile, true);
        const passwordResponse = await this.challenges.promptForChallengeResponse(challenge);
        if (passwordResponse == undefined) {
            return Result.fail('Import aborted due to canceled password prompt');
        }
        this.challenges.completeChallenge(challenge);
        return Result.ok(passwordResponse === null || passwordResponse === void 0 ? void 0 : passwordResponse.values[0].value);
    }
}
